import { createContext, createElement, useContext, useEffect, useMemo, useState } from "react";
import { api } from "./api";
import { useLiveTick } from "./live";
import { useI18n } from "./i18n";

const SiteContext = createContext({ settings: null, locations: [], categories: [] });

export function SiteProvider({ children }) {
  const [state, setState] = useState({ settings: null, locations: [], categories: [] });
  const tick = useLiveTick();
  useEffect(() => {
    Promise.all([api.get("/settings"), api.get("/locations"), api.get("/categories")])
      .then(([s, l, c]) => setState({ settings: s.data, locations: l.data, categories: c.data }))
      .catch(() => {});
  }, [tick]);
  return createElement(SiteContext.Provider, { value: state }, children);
}

export function useSite() {
  const ctx = useContext(SiteContext);
  const { lang } = useI18n();
  return useMemo(() => {
    const byKind = (kind) => ctx.categories.filter((c) => c.kind === kind);
    const label = (kind, key) => {
      const c = ctx.categories.find((x) => x.kind === kind && x.key === key);
      return c ? c[`label_${lang}`] : key;
    };
    const city = (slug) => ctx.locations.find((l) => l.slug === slug);
    const cityName = (slug) => city(slug)?.[`name_${lang}`] || slug;
    const nbName = (citySlug, nb) => city(citySlug)?.neighborhoods.find((n) => n.slug === nb)?.[`name_${lang}`] || nb;
    return { ...ctx, byKind, label, city, cityName, nbName };
  }, [ctx, lang]);
}
